module.exports = __webpack_public_path__ + "static/ms-icon-310x310.45aace31.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/favicons/ms-icon-310x310.png
// module id = 660
// module chunks = 114276838955818